var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 81,
    viewBox: "0 0 77 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 81H45.892V61.2137L67.452 0H77V81ZM31.108 81H0V61.2137L21.56 0H31.108V81Z",
    fill: "#C71B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartQuote);
export default __webpack_public_path__ + "static/media/StartQuote.ea4107031ed0dd5e29def7b37bfff119.svg";
export { ForwardRef as ReactComponent };